<div class="card mb-2">
  <div class="card-body">
    <div class="card-title row">
      <div class="col">
        <a [routerLink]="'/offers/' + data.id">
          <i class="fas fa-eye pr-1" style="font-size: larger"></i>
          <h5>{{ data.id }}</h5>
        </a>
      </div>
      <div class="col-auto ml-auto">
        <lib-action-btn [item]="data" [config]="configService"></lib-action-btn>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12 col-md-4">
        <div class="pb-1">
          <lib-gung-text-input
            *ngIf="data.extra.gme?.customerName"
            [gungTranslate]="'NAME'"
            [renderStatic]="true"
            [ngModel]="data.extra.gme.customerName"
          >
          </lib-gung-text-input>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="pb-1">
          <lib-gung-date-output
            [gungTranslate]="'OFFER_DATE'"
            [value]="data.extra.gme?.offerDate"
            *ngIf="data.extra.gme?.offerDate"
          >
          </lib-gung-date-output>
        </div>
        <div class="pb-1">
          <!--          <lib-gung-date-output-->
          <!--            [gungTranslate]="'EXPIRE_DATE'"-->
          <!--            [value]="data.extra.gme?.dueDate"-->
          <!--            *ngIf="data.extra.gungSalesOrder?.dueDate"-->
          <!--          >-->
          <!--          </lib-gung-date-output>-->
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="pb-1">
          <lib-gung-text-input
            *ngIf="data.extra?.gme?.totalGrossPrice"
            [gungTranslate]="'TOTAL'"
            [renderStatic]="true"
            [ngModel]="
              data.extra.gme.totalGrossPrice | gungCurrency: data.extra.gme.currencyCode : 'symbol-narrow' : '1.2-2'
            "
          >
          </lib-gung-text-input>
        </div>
        <div class="pb-1">
          <lib-gung-text-input
            *ngIf="data.extra?.gme?.totalNetPrice"
            [gungTranslate]="'TOTAL_INCLUDING_VAT'"
            [renderStatic]="true"
            [ngModel]="
              data.extra.gme.totalNetPrice | gungCurrency: data.extra.gme.currencyCode : 'symbol-narrow' : '1.2-2'
            "
          >
          </lib-gung-text-input>
        </div>
      </div>
    </div>
  </div>
</div>
